import React from "react";
import "./index.scss";
import "tachyons";
import Nav from "./Nav";
import Menu from "./Menu";
import Order from "./Order";
import Discounts from "./Discounts";
import Profile from "./Profile";
import Matrices from "./Matrices";
function App() {
  return (
    <div className="parent">
      <Nav />
      <Profile/>
    </div>
  );
}

export default App;
